import React, { useState } from 'react';
import { Button, Modal, Tooltip, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { EmptyData } from "../../../../../components/empty/emptyData";
import { EntProduct } from "../../../../../models/handBooks/product";
import { useLazyGetAllProductListQuery } from "../../../../../redux/api/handBooksApi/chemicalization/production";
import { ContentPartFilter } from "../../../../../components/content-part/ContentPartFilter";
import { useTypeProduct } from './useTypeProduct';
import { AddProduct } from "./AddProduct";
import { PageHeader } from '../../../../../components/page-header';
import { FilterByNameHB } from "../../../../../components/filterByNameHB/FilterByNameHB";
import { EntInitialFilter } from "../../../../../models/filters/initialFilter";
import _ from "lodash";

enum FormField {
  name
}

export const TypeOfProduct = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedItem, setSelectedItem] = useState<EntProduct>(new EntProduct());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [form] = useForm();
  const { t } = useTranslation();

  const {
	onAddProduct,
	onDeleteProduct,
	onEditProduct
  } = useTypeProduct(Modal, () => {
	searchHandleClick();
  });

  const [height, setHeight] = useState<number>(0);
  const [getAllProductList] = useLazyGetAllProductListQuery();

  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntProduct, EntInitialFilter>({
	initialFilter: new EntInitialFilter(),
	query: getAllProductList
  });

  const openAddModal = (item: EntProduct) => {
	setSelectedItem(item);
	setShowModal(true);
  };

  const setEntityFromFields = (): EntInitialFilter => {
	let filt: EntInitialFilter = _.clone(filter);
	filt.name = form.getFieldValue(FormField.name) ?? null;
	filt.page = 1;
	return filt;
  }
  const clearFields = () => {
	form.setFields([
	  { name: FormField.name, value: null },
	]);
  }

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('general.nameKy') }</th>
		  <th>{ t('general.nameRu') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ? (
		  <tr>
			<td colSpan={ 4 }>
			  <div className="table-loading">
				<Typography.Text type="secondary">{ t('general.loading') }</Typography.Text>
			  </div>
			</td>
		  </tr>
		) : data.length === 0 ? (
		  <tr>
			<td colSpan={ 4 }>
			  <EmptyData/>
			</td>
		  </tr>
		) : (
		  data.map((item: EntProduct, index: number) => (
			<tr key={ item.id }>
			  <td>{ index + 1 }</td>
			  <td>{ item.nameKy }</td>
			  <td>{ item.nameRu }</td>
			  <td>
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button
					  className='btn_edit'
					  onClick={ () => openAddModal(item) }
					  type="primary"
					  shape="circle"
					  icon={ <EditOutlined/> }
					/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button
					  className='btn_edit'
					  danger
					  onClick={ () => onDeleteProduct(item) }
					  type="primary"
					  shape="circle"
					  icon={ <DeleteOutlined/> }
					/>
				  </Tooltip>
				) }
			  </td>
			</tr>
		  ))
		) }
		</tbody>
	  </table>
	</div>
  );

  return (
	<>
	  <PageHeader
		title={ t('titles.products') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type="secondary">
			{ t('handbooks.types_of_products.Products') } { t('general.records_found') } { totalItems }
		  </Typography.Text>
		}
	  />

	  { access && access.methodPost && (
		<Button
		  type="primary"
		  icon={ <PlusOutlined/> }
		  onClick={ () => openAddModal(new EntProduct()) }
		>
		  { t('general.add') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={
		  <FilterByNameHB
			onSearch={ searchHandleClick }
			onReset={ () => {
			  clearFields();
			  searchHandleClick();
			} }
			formField={ FormField }
			form={ form }
		  />
		}
		setHeight={ setHeight }
		table={ table }
	  />

	  <AddProduct
		productCategory={ selectedItem }
		show={ showModal }
		onHide={ () => setShowModal(false) }
		onSubmit={ selectedItem.id !== null ? onEditProduct : onAddProduct }
	  />
	  { contextHolder }
	</>
  );
};
